import React, { useContext, useEffect, useState } from "react";
import styles from "./ExpiredApprovalModal.module.css";
import { currentRequestTimeStamp, isMobile } from "../../../../Constants";
import { checkModuleAccess, titleCase } from "../../../../Utility";
import classes from "../../TrucksAvailable.module.css";
import Axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import Loader from "../../../Loader";
import { toast } from "react-toastify";
import { mailerAPI } from "../../../Freightrates1/Utility";
// import { UserApiContext } from '../../../UserDetailsContext/UserDetailsContext'
import { EditableEmailsContext } from "../../../../Context/EditableEmailsContext";
import { DataGhost } from "../../../Planning/components/EmptyState";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import EnquiriesTab from "./EnquiriesTab";
import NewProfileModal from "../../../Shared/NewTransporterProfileModal/NewProfileModal";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { checkSQL } from "../../../CompanyProfileNew/FreightMaster/Utility/utility";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

const formatDOP = (dateString) => {
  if (!dateString || dateString === "NA") return "NA";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const PendingApproval = ({
  autoPushIndent = false,
  setsend_data,
  enquiryTransition,
}) => {
  // const [enquirydata, setenquirydata] = useState([])
  const [approvalList, setApprovallist] = useState([]);
  const [show, setShow] = useState(false);
  const [payload, setPayload] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [enquiryList, setEnquiryList] = useState([]);
  const [skipActive, setSkipactive] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedTab, setSelectedTab] = useState("enquiries");
  const [selectAll, setSelectAll] = useState(false);
  const [company_id, setcompany_id] = useState("");
  const isMandatoryApprovalRemark = companySettingData?.enquiry?.mandatory_approval_remark === true;
  // ── Expired DOP confirmation modal state ──────────────────────────────────
  const [dopModalOpen, setDopModalOpen] = useState(false);
  const [dopModalItems, setDopModalItems] = useState([]);   // [{enquiry, transporter}]
  // Per-enquiry settings: { [truck_enquiry_id]: { changeDop, newDop, newStartTime, newEndTime } }
  const [dopEnquirySettings, setDopEnquirySettings] = useState({});
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [activeTransporter, setactiveTransporter] = useState({ id: "", name: "" });

  const handleOpenProfile = (e, transporter) => {
    e.stopPropagation();
    setactiveTransporter({
      id: transporter.transporter_id,
      name: transporter.transporter_name,
    });
    setOpenProfileModal(true);
  };

  const handleCloseModal = () => {
    setOpenProfileModal(false);
    setactiveTransporter({ id: "", name: "" });
  };
  // ─────────────────────────────────────────────────────────────────────────
  const { companyProfile } = useContext(UserApiContext);
  const [emailTemplate, setemailTemplate] = useState({
    requestApprovalContent: "",
    requestApprovalFrom: "",
    requestApprovalSubject: "",
    requestApprovalCC: [],
    acceptedContentTransporter: "",
    acceptedFromTransporter: "",
    acceptedSubjectTransporter: "",
    acceptedContent: "",
    acceptedFrom: "",
    acceptedSubject: "",
    rejectedContentTransporter: "",
    rejectedFromTransporter: "",
    rejectedSubjectTransporter: "",
    rejectedContent: "",
    rejectedFrom: "",
    rejectedSubject: "",
    counterofferContentTransporter: "",
    counterofferFromTransporter: "",
    counterofferSubjectTransporter: "",
    counterofferContent: "",
    counterofferFrom: "",
    counterofferSubject: "",
  });
  var company_name = localStorage.getItem("companyname");
  var company_mail = localStorage.getItem("useremail");
  const emailData = useContext(EditableEmailsContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  /**
   * Handles the logic for displaying and processing enquiries in the approval workflow.
   *
   * @component
   * @param {Object} props - The component props.
   * @param {Array} props.payload - The current payload of selected transporters.
   * @param {Array} props.enquiryList - The list of enquiries to be displayed.
   * @param {Object} props.emailData - The email template data.
   * @param {Function} props.setShow - Function to set the loading state.
   * @param {Function} props.setPayload - Function to update the payload state.
   * @param {Function} props.setEnquiryList - Function to update the enquiry list state.
   * @param {Function} props.setApprovallist - Function to update the approval list state.
   * @param {Function} props.setemailTemplate - Function to update the email template state.
   * @param {Object} props.remarks - The remarks for each enquiry.
   * @param {boolean} props.autoPushIndent - Flag to determine if indents should be automatically pushed.
   * @returns {void}
   */
  useEffect(() => {
    setShow(true);

    if (emailData) {
      // setShow(false);
      setemailTemplate({
        acceptedContentTransporter:
          emailData?.transporterReceivesAcceptingMail?.content,
        acceptedFromTransporter:
          emailData?.transporterReceivesAcceptingMail?.from,
        acceptedSubjectTransporter:
          emailData?.transporterReceivesAcceptingMail?.subject,
        acceptedCCTransporter: emailData?.transporterReceivesAcceptingMail?.cc,
        acceptedContent: emailData?.clientReceivesAcceptingMail?.content,
        acceptedFrom: emailData?.clientReceivesAcceptingMail?.from,
        acceptedSubject: emailData?.clientReceivesAcceptingMail?.subject,
        acceptedCC: emailData?.clientReceivesAcceptingMail?.cc,
        rejectedContentTransporter:
          emailData?.transporterReceivesRejectionMail?.content,
        rejectedFromTransporter:
          emailData?.transporterReceivesRejectionMail?.from,
        rejectedSubjectTransporter:
          emailData?.transporterReceivesRejectionMail?.subject,
        rejectedCCTransporter: emailData?.transporterReceivesRejectionMail?.cc,
        rejectedContent: emailData?.clientReceivesRejectionMail?.content,
        rejectedFrom: emailData?.clientReceivesRejectionMail?.from,
        rejectedSubject: emailData?.clientReceivesRejectionMail?.subject,
        rejectedCC: emailData?.clientReceivesRejectionMail?.cc,
        counterofferContentTransporter:
          emailData?.transporterReceivesCounterMail?.content,
        counterofferFromTransporter:
          emailData?.transporterReceivesCounterMail?.from,
        counterofferSubjectTransporter:
          emailData?.transporterReceivesCounterMail?.subject,
        counterofferCCTransporter:
          emailData?.transporterReceivesCounterMail?.cc,
        counterofferContent: emailData?.clientReceivesCounterMail?.content,
        counterofferFrom: emailData?.clientReceivesCounterMail?.from,
        counterofferSubject: emailData?.clientReceivesCounterMail?.subject,
        counterofferCC: emailData?.clientReceivesCounterMail?.cc,
        requestApprovalContent:
          emailData?.clientReceivesApprovalLaneRequestMail?.content,
        requestApprovalFrom:
          emailData?.clientReceivesApprovalLaneRequestMail?.from,
        requestApprovalSubject:
          emailData?.clientReceivesApprovalLaneRequestMail?.subject,
        requestApprovalCC: emailData?.clientReceivesApprovalLaneRequestMail?.cc,
      });
    }
  }, []);
  //Updates Company_id in a setcompany_id state
  useEffect(() => {
    var id = "";
    if (companyProfile) {
      if (companyProfile.domain_data && companyProfile.domain_data.company_id) {
        id = companyProfile.domain_data.company_id;
        setcompany_id(id);
      }
    }
  }, []);
  //Fetches the details according to the selected tab
  useEffect(() => {
    fetchDetails(skipActive);
  }, [selectedTab]);

  const getPendingApprovalField = () => {
    if (selectedTab === "expiredDOP") return "fetch_expired_dop";
    if (selectedTab === "expiredEnquiries") return "fetch_expired";
    return undefined;
  };

  //Fetches the Details (Pending approval enquiries)
  const fetchDetails = (skip) => {
    setShow(true);
    Axios.post(`${Urls.spot}?field=approval_pending_enq_v2`, {
      email: localStorage.getItem("useremail"),
      field: getPendingApprovalField(),
      skip: skip ? (skip - 2) * 10 + 10 : (skipActive - 1) * 10 + 10,
      limit: 10,
    })
      .then((res) => {
        if (res.data.enquiry_list && res.data.enquiry_list.length > 0) {
          const normalizedEnquiries = res.data.enquiry_list.map((item) => {
            const rawTList = item.transporter_list || item.transporter_rate_list || [];

            // Deduplicate transporter list by transporter_id to prevent UI bugs
            const tList = [];
            const seenIds = new Set();
            rawTList.forEach(t => {
              if (!seenIds.has(t.transporter_id)) {
                seenIds.add(t.transporter_id);
                tList.push(t);
              }
            });

            return { ...item, transporter_list: tList };
          });
          setEnquiryList(normalizedEnquiries);
          setTotalCount(res.data?.total_enquiry);
          setApprovallist(normalizedEnquiries);
        } else {
          setApprovallist([]);
          setTotalCount(0);
          setEnquiryList([]);
        }
        setShow(false);
      })
      .catch((e) => {
        console.log(e);
        setShow(false);
      });
  };
  /**
   * Handles changes to the transporter selection and updates the payload accordingly.
   *
   * @param {Object} e - The event object.
   * @param {Object} item - The enquiry item.
   * @param {Object} transporter - The transporter object.
   * @returns {void}
   */
  const changeHandler = (e, item, transporter) => {
    const transporterData = {
      truck_enquiry_id: item.truck_enquiry_id,
      transporter_id: transporter.transporter_id,
      remark: "",
    };

    if (e.target.checked) {
      setPayload((prevPayload) => {
        const clearedPayload = prevPayload.filter(
          (data) => data.truck_enquiry_id !== item.truck_enquiry_id
        );
        return [...clearedPayload, transporterData];
      });
    } else {
      setPayload((prevPayload) =>
        prevPayload.filter(
          (data) =>
            data.truck_enquiry_id !== transporterData.truck_enquiry_id ||
            data.transporter_id !== transporterData.transporter_id
        )
      );
      setSelectAll(false);
    }
  };

  /**
   * Handles Reject and Open flow
   * @param {Array} enquiries.
   * @returns {void}
   */
  const RejectAndOpen = (enquiries, selectedPayload) => {
    let final = [];
    const sourcePayload = selectedPayload || payload;
    if (enquiries && enquiries.length > 0) {
      enquiries.map((item, index) => {
        let finalList = [];
        if (
          item.benchmark_transporter_list &&
          item.benchmark_transporter_list.length > 0
        ) {
          finalList = item.benchmark_transporter_list.map((t) => ({
            ...t,
            ischecked: t.ischecked ?? t.isChecked ?? true,
          }));
        }

        const currentPayload =
          sourcePayload.find((p) => p.truck_enquiry_id === item.truck_enquiry_id) ||
          sourcePayload[index] ||
          {};

        final.push({
          additional_details: item.additional_details ?? "",
          benchmark_transporter_list: finalList ?? [],
          open_remark: currentPayload.remark ?? "",
          open_enquiry_transporter_id: currentPayload.transporter_id,
          open_truck_enquiry_id: currentPayload.truck_enquiry_id,
          deselect_all: item.deselect_all ?? true,
          previous_truck_enquiry_id: item.truck_enquiry_id || currentPayload.truck_enquiry_id || "",
          disabled: false,
          is_seen: false,
          module_key: item.module_key ?? "Lorri_spot",
          lane_details: {
            origin: item.lane_details?.origin ?? {},
            destination: item.lane_details?.destination ?? {},
            drop: item.lane_details?.drop ?? "oneway",
            drop_locations: item.lane_details?.drop_locations ?? [],
            truck_types: item.lane_details?.truck_types ?? [],
            truck_required: item.lane_details?.truck_required ?? 0,
            due_date: "",
            submission_date: "",
            contract_tenure: item.lane_details?.contract_tenure ?? [],
            capacity:
              item.lane_details?.tonnage_unit ??
              item.lane_details?.capacity ??
              "MT",
            tonnage:
              item.lane_details?.tonnage &&
                item.lane_details?.tonnage !== "0" &&
                item.lane_details?.tonnage !== 0
                ? String(item.lane_details?.tonnage)
                : "",
            product_types:
              item.lane_details?.product_types ?? item.product_types ?? [],
            document_details: item.lane_details?.sales_invoice_number ?? "",
            dop_start_time: "",
            dop_end_time: "",
          },
        });
      });
    }
    setsend_data(final);
  };

  /**
   * Handles the approval of selected enquiries and processes related tasks.
   *
   * @returns {void}
   */
  // ── Expired DOP modal: helpers ────────────────────────────────────────────
  const updateEnquirySetting = (truck_enquiry_id, field, value) => {
    setDopEnquirySettings(prev => ({
      ...prev,
      [truck_enquiry_id]: { ...prev[truck_enquiry_id], [field]: value },
    }));
  };

  const isApproveReady = () => {
    return dopModalItems.every(({ enquiry }) => {
      const setting = dopEnquirySettings[enquiry.truck_enquiry_id];
      if (!setting || setting.changeDop === null) return false;
      if (setting.changeDop === true && !setting.newDop) return false;
      return true;
    });
  };

  const executeDopApproval = () => {
    if (isMandatoryApprovalRemark) {
      for (const { enquiry, transporter } of dopModalItems) {
        const tList = (enquiry.transporter_list || enquiry.transporter_rate_list || [])
          .filter(t => t.rate !== undefined && t.rate !== null)
          .slice()
          .sort((a, b) => parseFloat(a.rate) - parseFloat(b.rate));

        const rank = tList.findIndex(t => t.transporter_id === transporter.transporter_id);
        const remarkEntry = payload.find(p => p.truck_enquiry_id === enquiry.truck_enquiry_id);

        if (rank > 0 && (!remarkEntry?.remark || remarkEntry.remark.trim() === "")) {
          toast.error(`Remark is mandatory (L${rank + 1}) — ${enquiry.display_adhoc_id || enquiry.truck_enquiry_id}`);
          return;
        }
      }
    }
    const modalEnquiries = dopModalItems.map(({ enquiry, transporter }) => {
      const lane = enquiry.lane_details || enquiry;
      const originalDop = lane.due_date || "";
      const setting = dopEnquirySettings[enquiry.truck_enquiry_id] || {};
      const useNew = setting.changeDop === true;
      return {
        truck_enquiry_id: enquiry.truck_enquiry_id,
        transporter_id: transporter.transporter_id,
        remark: payload.find(p => p.truck_enquiry_id === enquiry.truck_enquiry_id)?.remark || "",
        indent_dop: useNew ? setting.newDop : originalDop,
        indent_start_time: useNew ? (setting.newStartTime || "") : "",
        indent_end_time: useNew ? (setting.newEndTime || "") : "",
      };
    });

    const bypassedEnquiries = payload
      .filter(p => !dopModalItems.some(modalItem => modalItem.enquiry.truck_enquiry_id === p.truck_enquiry_id))
      .map(p => ({
        truck_enquiry_id: p.truck_enquiry_id,
        transporter_id: p.transporter_id,
        remark: p.remark || "",
      }));

    const enquiries = [...modalEnquiries, ...bypassedEnquiries];

    setDopModalOpen(false);
    setShow(true);
    Axios.put(`${Urls.spot}?field=bulk_operation_v2`, { enquiries })
      .then(res => {
        setShow(false);
        if (res.data?.status === "error") {
          toast.info(res.data?.message);
          return;
        }

        if (res.data?.results && Array.isArray(res.data.results)) {
          const failures = res.data.results.filter(r => r.status === "failed");
          if (failures.length > 0) {
            failures.forEach(f => {
              toast.error(`${f.display_adhoc_id || f.truck_enquiry_id}: ${f.reason}`);
            });
            if (failures.length === res.data.results.length) {
              setPayload([]);
              fetchDetails(skipActive);
              return;
            }
          }
        }

        toast.success("Enquiries Approved Successfully!");
        setPayload([]);
        setDopModalItems([]);
        setDopEnquirySettings({});
        fetchDetails(skipActive);
        document.getElementById("close_contactus")?.click();
      })
      .catch(e => { console.log(e); setShow(false); });
  };
  // ─────────────────────────────────────────────────────────────────────────

  const ApprovalHandler = (type) => {
    if (payload.length === 0) {
      toast.error(
        `Please select at least one enquiry to ${type === "approve"
          ? "Approve"
          : type === "open"
            ? "Reject and Open"
            : "Reject and Close"
        }`
      );
      return;
    }
    const truckEnquiryIds = payload.map(
      (transporterData) => transporterData.truck_enquiry_id
    );
    const remarks = payload.every(
      (data) => data.remark !== "" && checkSQL(data.remark) === false
    );
    payload.map((item) => {
      return TrackMixPanel({
        ModuleName: "lorri spot",
        ScreenName: "my enquiries - enquiry pending for approval",
        Data: `truck enquiry id : ${item?.truck_enquiry_id}, remark : ${item?.remark}, transporter id: ${item?.transporter_id}`,
        Definition: `user has clicked on ${type === "approve"
          ? "approve"
          : type === "open"
            ? "reject and open"
            : "reject and close"
          } button`,
      });
    });
    if (type === "approve" && isMandatoryApprovalRemark) {
      for (const p of payload) {
        const enquiry = enquiryList.find(e => e.truck_enquiry_id === p.truck_enquiry_id);
        if (!enquiry) continue;

        const tList = (enquiry.transporter_list || enquiry.transporter_rate_list || [])
          .filter(t => t.rate !== undefined && t.rate !== null)
          .slice()
          .sort((a, b) => parseFloat(a.rate) - parseFloat(b.rate));

        const rank = tList.findIndex(t => t.transporter_id === p.transporter_id);

        if (rank > 0 && (!p.remark || p.remark.trim() === "")) {
          toast.error(`Remark is mandatory for (L${rank + 1}) — ${enquiry.display_adhoc_id || enquiry.truck_enquiry_id}`);
          return;
        }
      }
    }
    // ── For expiredDOP + approve: skip window.confirm, open custom modal ─────
    if (type === "approve" && selectedTab === "expiredDOP") {
      const items = payload.map(p => {
        const enquiry = enquiryList.find(e => e.truck_enquiry_id === p.truck_enquiry_id);
        const tList = enquiry?.transporter_list || enquiry?.transporter_rate_list || [];
        const transporter = tList.find(t => t.transporter_id === p.transporter_id);
        return { enquiry, transporter };
      }).filter(x => x.enquiry && x.transporter);

      const requiresModal = items.filter(x => x.enquiry.indent_created !== true);

      if (requiresModal.length > 0) {
        setDopModalItems(requiresModal);
        // initialise per-enquiry settings
        const initSettings = {};
        requiresModal.forEach(({ enquiry }) => {
          initSettings[enquiry.truck_enquiry_id] = { changeDop: null, newDop: "", newStartTime: "", newEndTime: "" };
        });
        setDopEnquirySettings(initSettings);
        setDopModalOpen(true);
        return;
      }
    }
    // ─────────────────────────────────────────────────────────────────────────

    if (
      window.confirm(
        `Are you sure to ${type === "approve"
          ? "Approve Selected Enquiries"
          : type === "open" && remarks === true
            ? "Reject and Open Selected Enquiries"
            : type === "open" && remarks === false
              ? "Reject and Open Selected Enquiries without Remarks"
              : type === "close" && remarks === true
                ? "Reject and Close Selected Enquiries"
                : "Reject and Close Selected Enquiries without Remarks"
        }?`
      )
    ) {
      const finalFieldValue =
        type === "approve"
          ? "bulk_operation_v2"
          : "bulk_operation_v2&operation=rejection";
      if (type === "open" && selectedTab === "expiredDOP") {
        setShow(true);
        const currentSelection = [...payload];
        Axios.post(`${Urls.spot}?field=fetch_enquries_v2`, {
          truck_enquiry_ids: truckEnquiryIds,
        })
          .then((res) => {
            setShow(false);
            if (res && res.data && res.data.enquiry_lane_details) {
              RejectAndOpen(res.data.enquiry_lane_details, currentSelection);
              toast.success("Enquiries Opened Successfully!");
              setPayload([]);
              fetchDetails(skipActive);
              document.getElementById("close_contactus")?.click();
            }
          })
          .catch((e) => {
            console.log(e);
            setShow(false);
          });
      } else {
        let enquiries = {};
        if (type === "approve") {
          enquiries = payload.map((transporterData) => ({
            ...transporterData,
          }));
        } else if (type === "close") {
          enquiries = {
            company_id: company_id,
            action: "rejectandclose",
            enquiries: payload.map((transporterData) => ({
              ...transporterData,
            })),
          };
        } else if (type === "open") {
          enquiries = {
            company_id: company_id,
            action:
              selectedTab === "enquiries" ? "rejectandopen" : "rejectandclose",
            enquiries: payload.map((transporterData) => ({
              ...transporterData,
            })),
          };
        }

        const finalPayload = type === "approve" ? { enquiries } : enquiries;
        Axios.put(`${Urls.spot}?field=${finalFieldValue}`, finalPayload)
          .then(res => {
            setShow(false);
            if (res.data?.status === "error") {
              toast.info(res.data?.message);
              return;
            }

            const results = res.data?.results || (Array.isArray(res.data) ? res.data : []);
            if (Array.isArray(results) && results.length > 0) {
              const failures = results.filter(r => r.status === "failed");
              if (failures.length > 0) {
                failures.forEach(f => {
                  toast.error(`${f.display_adhoc_id || f.truck_enquiry_id}: ${f.reason}`);
                });
                if (failures.length === results.length) {
                  setPayload([]);
                  fetchDetails(skipActive);
                  return;
                }
              }
            }

            if (res && res.data) {
              toast.success(`Enquiries ${type === "approve" ? "Approved" : type === "open" ? "Rejected and Open" : "Rejected and Closed"} Successfully!`);
              setPayload([])
              fetchDetails(skipActive);
            }
            if (results && results.length > 0 && autoPushIndent && autoPushIndent === true && (enquiryTransition || enquiryTransition === true)) {
              var new_indents = [];
              if (results && results.length > 0) {
                results.map((enquiry) => {
                  if (enquiry && enquiry.enquiry_lane_details && enquiry.enquiry_lane_details.length > 0) {
                    enquiry.enquiry_lane_details.map((enq) => {
                      const tList = enq.transporter_list || enq.transporter_rate_list || [];
                      if (tList.length > 0 && tList.filter((transporter) => transporter.main_status === 'approved').length > 0) {
                        new_indents.push({
                          "destination": enq.destination,
                          "origin": enq.origin,
                          "placement_date": enq.due_date,
                          "shortlisted_transporters": tList
                            .filter((transporter) => {
                              if (transporter.main_status === 'approved') {
                                transporter['is_shortlist'] = true;
                                return transporter;
                              }
                            })
                            .map((t, idx) => ({
                              ...t,
                              rank: idx === 0 ? 'L1' : t.rank
                            })),
                          "truck_required": enq.truck_required,
                          "truck_types": Array.isArray(enq.truck_types) ? enq.truck_types : [enq.truck_types],
                          "from": "adhoc",
                          "display_indent_id": enq.display_adhoc_id,
                          "capacity": enq.capacity,
                          "tonnage": enq.tonnage
                        });
                      }
                    });
                  }
                });
              }
              if (enquiries && enquiries.length > 0) {
                var list = enquiries.flatMap((enquiry) => {
                  return enquiryList.filter(enq => enq.truck_enquiry_id === enquiry.truck_enquiry_id);
                });
              }
              var list = enquiries.flatMap((enquiry) => {
                return enquiryList.filter(enq => enq.truck_enquiry_id === enquiry.truck_enquiry_id);
              });
              list.map((item) => {
                sendMail("accepted", enquiries, item.benchmark_transporter_list, item);
              });
            }
            if (type === "approve" && autoPushIndent && autoPushIndent === true && (enquiryTransition || enquiryTransition === true)) {
              // Frontend createIndent is moved to backend. Keep old logic for reference.
              // Axios.post(Urls.createIndent, { "indents": new_indents })
              //   .then(res => {
              //     toast.success("Indents floated successfully")
              //     // console.log(res.data, '115')
              //     truckEnquiryIds.map(truckEnquiryId => {
              //       const indent = {
              //         truck_enquiry_id: truckEnquiryId,
              //         indent_created: true
              //       };
              //
              //       Axios.post(`${Urls.spot}?edit_enquiry=true`, indent)
              //         .then(res => {
              //           // setShow(false);
              //           console.log(res);
              //         })
              //         .catch(e => console.log(e));
              //     });
              //   })
              //   .catch(err => {
              //     console.log(err)
              //     setShow(false);
              //   })
              truckEnquiryIds.map(truckEnquiryId => {
                const indent = {
                  truck_enquiry_id: truckEnquiryId,
                  indent_created: true
                };

                Axios.post(`${Urls.spot}?edit_enquiry=true`, indent)
                  .then(res => {
                    console.log(res);
                  })
                  .catch(e => console.log(e));
              });
              toast.success("Indent moved successfully");
            }
            // if (type === "open" && selectedTab === "expiredDOP") {
            //     if (res && res.data && res.data.result) {
            //         RejectAndOpen(res.data.result)
            //     }
            // }
            // document.getElementById('close_contactus').click();
          })
          .catch(e => {
            console.log(e);
            setShow(false)
          });
      }
      document.getElementById("close_contactus").click();
    }
  };

  /**
   * Sends an email and SMS to the relevant parties based on the approval status of an enquiry.
   *
   * @param {string} value - The approval status ("accepted" or "rejected").
   * @param {Array} enquiries - The list of enquiries.
   * @param {Array} new_tlist - The list of new shortlisted transporters.
   * @param {Object} item - The specific enquiry item.
   * @returns {void}
   */
  const sendMail = (value, enquiries, new_tlist, item) => {
    try {
      // Determine if the user is an approver
      var isApprover = true;

      // Find the transporter details from the enquiries list
      const tList = item.transporter_list || item.transporter_rate_list || [];
      var transporter = tList.flatMap((enq_transporter) => {
        return enquiries.filter(
          (transporter) =>
            transporter.transporter_id === enq_transporter.transporter_id
        );
      })[0];

      // Function to format date as dd-mm-yyyy
      const mydate = (inputdate) => {
        var mindate = new Date(inputdate);
        var day = ("0" + mindate.getDate()).slice(-2);
        var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
        var year = mindate.getFullYear();
        return `${day}-${month}-${year}`;
      };

      // HTML table to include in the email
      var localtablecompanyaccepted = `
                <table border="1">
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Date of Enquiry</th>
                        <th>Origin</th>
                        <th>Destination</th>
                        <th>Truck Type</th>
                        <th>#Trucks Required</th>
                        <th>Date of Placement/ Contract</th>
                        <th>Tenure</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>${mydate(item.submission_date)}</td>
                        <td>${item.lane_details?.origin.location_name}</td>
                        <td>${item.lane_details?.destination.location_name}</td>
                        <td>${Array.isArray(item.lane_details?.truck_types)
          ? item.lane_details?.truck_types.map((tt) => tt.value)
          : item.lane_details?.truck_types.label
        }</td>
                        <td>${item.lane_details?.truck_required ? item.lane_details?.truck_required : "NA"
        }</td>
                        <td>${item.lane_details?.due_date ? item.lane_details?.due_date : "NA"}</td>
                        <td>${item.lane_details?.contract_tenure &&
          item.lane_details?.contract_tenure.length > 0
          ? item.lane_details?.contract_tenure[0].value
          : "NA"
        }</td>
                    </tr>
                </tbody>
                </table>`;

      // Create the email body for the main recipient
      var emailBody = {
        activity: "Email Request",
        type: "superlaunch",
        mail_status: "Pending",
        from_email: `${value === "accepted"
          ? emailTemplate.acceptedFrom === "user"
            ? localStorage.getItem("useremail")
            : "connect@logisticsnow.in"
          : emailTemplate.rejectedFrom === "user"
            ? localStorage.getItem("useremail")
            : "connect@logisticsnow.in"
          }`,
        user_type: "company",
        cc: `${value === "accepted"
          ? emailTemplate.acceptedCC && emailTemplate.acceptedCC !== ""
            ? [""]
            : "connect@logisticsnow.in"
          : emailTemplate.rejectedCC && emailTemplate.rejectedCC !== ""
            ? [""]
            : "connect@logisticsnow.in"
          }`,
        subject: `${value === "accepted"
          ? emailTemplate.acceptedSubject
          : emailTemplate.rejectedSubject
          }`,
        to_email: localStorage.getItem("useremail"),
        Application_name: "lorri",
        module_name: "View Quotation",
        timestamp: currentRequestTimeStamp(),
        content: `${value === "accepted"
          ? eval("`" + emailTemplate.acceptedContent + "`")
          : eval("`" + emailTemplate.rejectedContent + "`")
          }`,
      };

      // Call mailerAPI to send the main email
      mailerAPI(emailBody, setShow);

      // Process each new shortlisted transporter
      if (new_tlist && new_tlist.length > 0) {
        new_tlist.map((shortlisted_transporter) => {
          if (
            shortlisted_transporter.transporter_id ===
            transporter.transporter_id
          ) {
            if (
              (shortlisted_transporter.contact_information &&
                shortlisted_transporter.contact_information.length > 0) ||
              (shortlisted_transporter.access_control &&
                shortlisted_transporter.access_control.length > 0)
            ) {
              shortlisted_transporter.contact_information.map((poc) => {
                // Check module access for the contact
                if (
                  checkModuleAccess(
                    shortlisted_transporter.access_control,
                    poc.contact_number,
                    "Company Enquiries",
                    localStorage.getItem("useremail").split("@")[1]
                  )
                ) {
                  // Create the email body for the transporter
                  var emailTransporterBody = {
                    activity: "Email Request",
                    Application_name: "lorri",
                    module_name: "View Quotation",
                    timestamp: currentRequestTimeStamp(),
                    to_email: `${poc.email}`,
                    type: "superlaunch",
                    mail_status: "Pending",
                    from_email: `${value === "accepted"
                      ? emailTemplate.acceptedFromTransporter === "user"
                        ? localStorage.getItem("useremail")
                        : "lorri@logisticsnow.in"
                      : emailTemplate.rejectedFromTransporter === "user"
                        ? localStorage.getItem("useremail")
                        : "lorri@logisticsnow.in"
                      }`,
                    user_type: "transporter",
                    cc: `${value === "accepted"
                      ? emailTemplate.acceptedCCTransporter &&
                        emailTemplate.acceptedCCTransporter !== ""
                        ? [""]
                        : "lorri@logisticsnow.in"
                      : emailTemplate.rejectedCCTransporter &&
                        emailTemplate.rejectedCCTransporter !== ""
                        ? [""]
                        : "lorri@logisticsnow.in"
                      }`,
                    subject: `${value === "accepted"
                      ? emailTemplate.acceptedSubjectTransporter
                      : emailTemplate.rejectedSubjectTransporter
                      }`,
                    content: `${value === "accepted"
                      ? eval(
                        "`" + emailTemplate.acceptedContentTransporter + "`"
                      )
                      : eval(
                        "`" + emailTemplate.rejectedContentTransporter + "`"
                      )
                      }`,
                  };

                  // Call mailerAPI to send the transporter email
                  mailerAPI(emailTransporterBody, setShow);

                  // Send SMS if contact number is available
                  if (
                    poc.contact_number &&
                    poc.contact_number !== null &&
                    poc.contact_number !== undefined
                  ) {
                    var contact = poc.contact_number.split("+91");
                    if (contact[0] === "") {
                      // Create the SMS body for the transporter
                      var smsTransporterBody = {
                        activity: "message_request",
                        type: "fast2sms",
                        sender_id: "LORRII",
                        message: `${value === "accepted" ? "144528" : "158789"
                          }`,
                        // "variables_values": `${company_name}`,
                        contact_number: `${contact[1]}`,
                        message_status: "Pending",
                        user_id: item.userid,
                        timestamp: currentRequestTimeStamp(),
                        transporter_name: transporter.transporter_name,
                        content: `${value === "accepted"
                          ? `${company_name} has accepted your quotation. Login to transporter.lorri.in for details. -Sent via Team LoRRI`
                          : `${company_name} has rejected your quotation. Login to transporter.lorri.in for details. -Sent via Team LoRRI`
                          }`,
                        route: "dlt",
                        transporter_id: transporter.transporter_id,
                        title: `${company_name}: Enquiry ${value === "accepted" ? "Approved" : "Rejected"
                          }`,
                        subtitle: "",
                        body: `${item.lane_details?.origin &&
                          item.lane_details?.origin.location &&
                          item.lane_details?.origin.location.location
                          ? item.lane_details?.origin.location.location
                          : ""
                          } ➤ ${item.lane_details?.destination &&
                            item.lane_details?.destination.location &&
                            item.lane_details?.destination.location.location
                            ? item.lane_details?.destination.location.location
                            : ""
                          }, ${Array.isArray(item.lane_details?.truck_types)
                            ? item.lane_details?.truck_types.map((tt) => tt.value)
                            : item.lane_details?.truck_types.label
                          }`,
                      };
                    } else {
                      var smsTransporterBody = {
                        activity: "message_request",
                        type: "fast2sms",
                        sender_id: "LORRII",
                        // "variables_values": `${company_name}`,
                        message: `${value === "accepted" ? "144528" : "158789"
                          }`,
                        contact_number: `${contact[0]}`,
                        message_status: "Pending",
                        user_id: item.userid,
                        timestamp: currentRequestTimeStamp(),
                        transporter_name: transporter.transporter_name,
                        route: "dlt",
                        transporter_id: transporter.transporter_id,
                        content: `${value === "accepted"
                          ? `${company_name} has accepted your quotation. Login to transporter.lorri.in for details. -Sent via Team LoRRI`
                          : `${company_name} has rejected your quotation. Login to transporter.lorri.in for details. -Sent via Team LoRRI`
                          }`,
                        title: `${company_name}: Enquiry ${value === "accepted" ? "Approved" : "Rejected"
                          }`,
                        subtitle: "",
                        body: `${item.lane_details?.origin &&
                          item.lane_details?.origin.location &&
                          item.lane_details?.origin.location.location
                          ? item.lane_details?.origin.location.location
                          : ""
                          } ➤ ${item.lane_details?.destination &&
                            item.lane_details?.destination.location &&
                            item.lane_details?.destination.location.location
                            ? item.lane_details?.destination.location.location
                            : ""
                          }, ${Array.isArray(item.lane_details?.truck_types)
                            ? item.lane_details?.truck_types.map((tt) => tt.value)
                            : item.lane_details?.truck_types.label
                          }`,
                      };
                    }

                    // Call mailerAPI to send the SMS
                    mailerAPI(smsTransporterBody, setShow);
                  }
                }
              });
            }
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getOnChange = (e) => {
    setSkipactive(e);
    fetchDetails(e);
  };
  const handleToggle = (val) => {
    // Track the tab click event with Mixpanel
    // mixpanel.track(`User has clicked on ${val === 'enquiries' ? "Enquiries" : "Exquiries with expired DOP"} Tab button`, {
    //     ApplicationName: `${Urls.mixpanelappname}`, // Application name from the URL configuration
    //     ScreenName: 'LoRRI-Spot',                 // Name of the screen where the event occurred
    //     ModuleName: 'Approver Screen',                  // Module name within the application
    //     ActivityLog: `userClickedTabButton`,         // Description of the activity logged
    //     Data: `User Clicked on ${val === 'enquiries' ? "Enquiries" : "Exquiries with expired DOP"} tab`, // Data on which tab was clicked
    //     Definition: `User has clicked on Tab button`, // Definition of the event
    //     ActivityType: 'event_view',                  // Type of activity tracked
    //     UserName: `${localStorage.getItem("userdetails")}`, // Username retrieved from local storage
    //     UserEmail: `${localStorage.getItem("useremail")}`, // User email retrieved from local storage
    //     CompanyName: `${localStorage.getItem("companyname")}` // Company name retrieved from local storage
    // });
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - enquiry pending for approval",
      Data: `None`,
      Definition: `user clicked on ${val === "enquiries" ? "enquiries" : "enquiries with expired dop"
        } tab`,
    });
    // Update state variables based on the tab clicked
    setSelectedTab(val); // Set the current tab value
    setSelectAll(false);
    setPayload([]);
  };
  const selectAllfunc = (e) => {
    let finalList = [];
    if (e.target.checked) {
      approvalList.forEach((item) => {
        const tList = item.transporter_list || item.transporter_rate_list || [];
        tList.forEach((transporter) => {
          const lastRate = transporter.rate_list?.[transporter.rate_list.length - 1];
          if (
            lastRate &&
            lastRate.bid_status === "accepted" &&
            (transporter.main_status === "approval_pending" ||
              lastRate.main_status === "approval_pending" ||
              (transporter.main_status !== "approved" && lastRate.main_status !== "approved"))
          ) {
            finalList.push({
              truck_enquiry_id: item.truck_enquiry_id,
              transporter_id: transporter.transporter_id,
              remark: "",
            });
          }
        });
      });
      setSelectAll(true);
      setPayload(finalList);
    } else {
      setPayload([]);
      setSelectAll(false);
    }
  };
  // ── Expired DOP helpers ──────────────────────────────────────────────────
  const getTenure = (tenure) => {
    if (!tenure) return "NA";
    if (typeof tenure === "string") return tenure;
    if (Array.isArray(tenure) && tenure.length > 0) return tenure[0].label || tenure[0].value || "NA";
    if (typeof tenure === "object") return tenure.label || tenure.value || "NA";
    return "NA";
  };
  // ─────────────────────────────────────────────────────────────────────────

  return (
    <>
      {/* ── Expired DOP Confirmation Modal ────────────────────────────── */}
      {dopModalOpen && (
        <div className={styles.overlay}>
          <div className={styles.modal}>
            {/* Header */}
            <div className={styles.header}>
              <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#393185' }}>
                <i className="fa fa-calendar-times-o mr-2" />
                Action Required: Expired Placement Dates
              </span>
              <button className={styles.closeBtn} onClick={() => setDopModalOpen(false)}>×</button>
            </div>

            {/* Body */}
            <div className={styles.body}>
              {/* ── Warning note (Prominent) ── */}
              {dopModalItems.length > 0 && (
                <div style={{
                  backgroundColor: '#fff4e5',
                  borderLeft: '4px solid #ff9800',
                  padding: '10px 12px',
                  borderRadius: '4px',
                  marginBottom: '12px'
                }}>
                  <p style={{ fontSize: '13px', color: '#663c00', margin: 0, fontWeight: '500' }}>
                    <i className="fa fa-info-circle mr-2" />
                    The placement dates for these enquiries have expired. Before approving, please choose whether to keep the original dates or set new ones.
                  </p>
                </div>
              )}

              {/* ── Per-enquiry Date of Placement controls ── */}
              <div style={{ marginTop: '6px' }}>
                {dopModalItems.map(({ enquiry, transporter }, idx) => {
                  const lane = enquiry.lane_details || enquiry;
                  const origin = lane.origin || enquiry.origin;
                  const destination = lane.destination || enquiry.destination;
                  const due_date = lane.due_date || enquiry.due_date;
                  const originName = origin?.location?.location || origin?.location_name || "NA";
                  const destName = destination?.location?.location || destination?.location_name || "NA";
                  const id = enquiry.truck_enquiry_id;
                  const setting = dopEnquirySettings[id] || {};
                  return (
                    <div key={id} style={{ borderBottom: '1px solid #eee', padding: '6px 0' }}>
                      {/* Compact single-line meta */}
                      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '6px', fontSize: '12px', color: '#444', marginBottom: '6px' }}>
                        <span style={{ fontWeight: 600, color: '#333' }}>{enquiry.display_adhoc_id || 'NA'}</span>
                        <span style={{ color: '#000000ff' }}>·</span>
                        <span>{originName} → {destName}</span>
                        <span style={{ color: '#000000ff' }}>·</span>
                        <span>{Array.isArray(lane.truck_types) ? lane.truck_types.map(t => t.label).join(", ") : (lane.truck_types?.label || lane.truck_types || "NA")}</span>
                        <span style={{ color: '#000000ff' }}>·</span>
                        <span
                          style={{ cursor: 'pointer', color: '#393185', fontWeight: 'bold', textDecoration: 'underline' }}
                          onClick={(e) => handleOpenProfile(e, transporter)}
                          title="View Transporter Profile"
                        >
                          {transporter.transporter_name}
                        </span>
                        <span style={{ color: '#000000ff' }}>·</span>
                        <span style={{ fontWeight: 600, color: '#393185' }}>₹{transporter.rate_list?.[transporter.rate_list.length - 1]?.rate?.toLocaleString() || "NA"}</span>
                        <span style={{ color: '#000000ff' }}>·</span>
                        <span>{lane.truck_required || enquiry.truck_required || "NA"} Trucks</span>
                        <span style={{ color: '#000000ff' }}>·</span>
                        <span>{getTenure(lane.contract_tenure || enquiry.contract_tenure)}</span>
                        <span style={{ color: '#000000ff' }}>·</span>
                        <span style={{ color: '#393185', fontWeight: 500 }}>DOP: {formatDOP(due_date)}</span>
                      </div>

                      {/* Clear Action Buttons with Solid Backgrounds */}
                      <div style={{ display: 'flex', gap: '8px', marginBottom: setting.changeDop === true ? '8px' : '4px' }}>
                        <button
                          style={{
                            fontSize: '11px',
                            padding: '6px 14px',
                            borderRadius: '4px',
                            border: '1px solid ' + (setting.changeDop === false ? '#27ae60' : '#ddd'),
                            backgroundColor: setting.changeDop === false ? '#27ae60' : '#f8f9fa',
                            color: setting.changeDop === false ? '#fff' : '#666',
                            fontWeight: '600',
                            cursor: 'pointer'
                          }}
                          onClick={() => updateEnquirySetting(id, 'changeDop', false)}
                        >
                          <i className={`fa ${setting.changeDop === false ? 'fa-check-circle' : 'fa-circle-o'} mr-1`} />
                          Keep Original Date
                        </button>
                        <button
                          style={{
                            fontSize: '11px',
                            padding: '6px 14px',
                            borderRadius: '4px',
                            border: '1px solid ' + (setting.changeDop === true ? '#393185' : '#ddd'),
                            backgroundColor: setting.changeDop === true ? '#393185' : '#f8f9fa',
                            color: setting.changeDop === true ? '#fff' : '#666',
                            fontWeight: '600',
                            cursor: 'pointer'
                          }}
                          onClick={() => updateEnquirySetting(id, 'changeDop', true)}
                        >
                          <i className={`fa ${setting.changeDop === true ? 'fa-edit' : 'fa-circle-o'} mr-1`} />
                          Change to New Date
                        </button>
                      </div>

                      {/* Date / time pickers — only when Yes */}
                      {setting.changeDop === true && (
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '4px' }}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <label style={{ fontSize: '11px', color: '#666', marginBottom: '0' }}>New DOP *</label>
                            <input
                              type="date"
                              value={setting.newDop || ''}
                              min={new Date().toISOString().split('T')[0]}
                              onChange={e => updateEnquirySetting(id, 'newDop', e.target.value)}
                              className="form-control form-control-sm"
                              style={{ fontSize: '12px', width: '140px' }}
                            />
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <label style={{ fontSize: '11px', color: '#666', marginBottom: '0' }}>Start Time</label>
                            <input
                              type="time"
                              value={setting.newStartTime || ''}
                              onChange={e => updateEnquirySetting(id, 'newStartTime', e.target.value)}
                              className="form-control form-control-sm"
                              style={{ fontSize: '12px', width: '120px' }}
                            />
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <label style={{ fontSize: '11px', color: '#666', marginBottom: '0' }}>End Time</label>
                            <input
                              type="time"
                              value={setting.newEndTime || ''}
                              onChange={e => updateEnquirySetting(id, 'newEndTime', e.target.value)}
                              className="form-control form-control-sm"
                              style={{ fontSize: '12px', width: '120px' }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

            </div>{/* end body */}

            {/* Footer */}
            <div className={styles.footer}>
              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => setDopModalOpen(false)}
              >Cancel</button>
              <button
                className="btn btn-sm btn-primary"
                disabled={!isApproveReady()}
                onClick={executeDopApproval}
                style={{ backgroundColor: "#393185", borderColor: "#393185" }}
              >Approve</button>
            </div>
          </div>
        </div>
      )}
      {/* ──────────────────────────────────────────────────────────────── */}
      <div>
        <Loader show={show} />
        <div>
          <div className={`mb-5 ${classes["main-div"]}`}>
            <ToggleButtonGroup
              type="radio"
              name="options"
              value={selectedTab}
              className={classes["toggle-group"]}
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              <ToggleButton
                value="enquiries"
                className="text-center"
                style={{
                  width: "33.33%",
                  whiteSpace: "nowrap",
                  backgroundColor: selectedTab === "enquiries" ? "#393185" : "transparent",
                  color: selectedTab === "enquiries" ? "white" : "#808080",
                  fontWeight: selectedTab === "enquiries" ? "bold" : "normal",
                  fontSize: "13px",
                  padding: "1.1% 0%",
                  borderRadius: "11px",
                }}
                variant={selectedTab === "enquiries" ? "#393185" : "light"}
                onChange={() => handleToggle("enquiries")}
              >
                Enquiries
              </ToggleButton>

              <ToggleButton
                value="expiredDOP"
                className="text-center"
                style={{
                  width: "33.33%",
                  whiteSpace: "nowrap",
                  backgroundColor: selectedTab === "expiredDOP" ? "#393185" : "transparent",
                  color: selectedTab === "expiredDOP" ? "white" : "#808080",
                  fontWeight: selectedTab === "expiredDOP" ? "bold" : "normal",
                  fontSize: "13px",
                  padding: "1.1% 0%",
                  borderRadius: "11px",
                }}
                variant={selectedTab === "expiredDOP" ? "#D3D3D3" : "light"}
                onChange={() => handleToggle("expiredDOP")}
              >
                Expired Placement Date
              </ToggleButton>

              <ToggleButton
                value="expiredEnquiries"
                className="text-center"
                style={{
                  width: "33.33%",
                  whiteSpace: "nowrap",
                  backgroundColor:
                    selectedTab === "expiredEnquiries" ? "#393185" : "transparent",
                  color: selectedTab === "expiredEnquiries" ? "white" : "#808080",
                  fontWeight: selectedTab === "expiredEnquiries" ? "bold" : "normal",
                  fontSize: "13px",
                  padding: "1.1% 0%",
                  borderRadius: "11px",
                }}
                variant={selectedTab === "expiredEnquiries" ? "#D3D3D3" : "light"}
                onChange={() => handleToggle("expiredEnquiries")}
              >
                Expired Enquiries
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          {selectedTab === "enquiries" ? (
            <EnquiriesTab
              approvalList={approvalList}
              payload={payload}
              setPayload={setPayload}
              selectAll={selectAll}
              selectAllfunc={selectAllfunc}
              changeHandler={changeHandler}
              getOnChange={getOnChange}
              skipActive={skipActive}
              totalCount={totalCount}
              show={show}
              ApprovalHandler={ApprovalHandler}
              enquiryTransition={enquiryTransition}
            />
          ) : (
            <EnquiriesTab
              approvalList={approvalList}
              payload={payload}
              setPayload={setPayload}
              selectAll={selectAll}
              selectAllfunc={selectAllfunc}
              changeHandler={changeHandler}
              getOnChange={getOnChange}
              skipActive={skipActive}
              totalCount={totalCount}
              show={show}
              ApprovalHandler={ApprovalHandler}
              enquiryTransition={enquiryTransition}
            />
          )}
        </div>
      </div>
      {openProfileModal && activeTransporter?.id !== "" && (
        <NewProfileModal
          isOpen={openProfileModal}
          onClose={handleCloseModal}
          transporter_id={activeTransporter.id}
          transporter_name={activeTransporter.name}
          screenName={"LoRRI Adhoc"}
          moduleName={"My Enquiries"}
          transporter_list={dopModalItems.map(item => item.transporter)}
        />
      )}
    </>
  );
};

export default PendingApproval;